<template>
    <div :class="['store-credibility', $prefixClass.card, $prefixClass.row]">
        <a-skeleton prefixCls="m-skeleton" :paragraph="{ rows: 6 }" active :loading="loading" button avatar>
            <div class="store-credibility__content">
                <div class="store-credibility__content__point m-t-12">
                    <a-progress type="circle" :percent="progress" :width="87" :strokeWidth="10" 
                        :stroke-color="speed_color[speed]" 
                        class="store-credibility__content__point__progress"/>
                    <div :class="['store-credibility__content__point__speed', 'speed-' + speed]">
                        <span>{{speed}}</span>
                    </div>
                    <a-badge :class="'speed-' + speed">
                        {{$t('dashboard.store_credibility.credibility')}}
                    </a-badge>
                </div>
                <div class="store-credibility__content__detail">
                    <h5 v-if="speed == 30 || speed == 100" class="m-b-8" v-html="$t(`dashboard.store_credibility.${appCredibility}.title`)"></h5>
                    <h6 v-else class="m-b-8" v-html="$t(`dashboard.store_credibility.${appCredibility}.title`)"></h6>
                    <p v-html="$t(`dashboard.store_credibility.${appCredibility}.line`)"></p>

                    <ul class="list">
                        <li v-html="$t(`dashboard.store_credibility.${appCredibility}.line_1`)"></li>
                        <li v-html="$t(`dashboard.store_credibility.${appCredibility}.line_2`)"></li>
                        <li v-html="$t(`dashboard.store_credibility.${appCredibility}.line_3`)"></li>
                    </ul>
                    <p v-if="speed !== 100">{{$t(`dashboard.store_credibility.${appCredibility}.des`)}}</p>
                </div>
            </div>
        </a-skeleton>
        <div class="store-credibility__footer" v-if="!loading">
            <template v-if="displaySpeed !== '61_100'">
                <template v-if="speed == 100">
                    <a-button type="primary" @click="openAppAR">{{$t(`dashboard.store_credibility.open_app`)}}</a-button>
                </template>
                <template v-else>
                    <a-button type="primary" @click="openAppAR">{{$t(`dashboard.store_credibility.explore_alireview`)}}</a-button>
                    <a :class="[$prefixClass.link]" target="_blank" href="https://ali-reviews-fireapps.myshopify.com/products/charmsmic-new-striped">{{$t(`dashboard.store_credibility.view_demo_store`)}} 
                    <i class="fa-regular fa-arrow-up-right-from-square m-l-3"></i></a>
                </template>
            </template> 
        </div>
    </div>
</template>
<script>

export default {
    name: 'StoreCredibility',
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        listApp: {
            type: Array,
            required: true
        }
    },
    components: {
        
    },
    data() {
        return {
            active: true,
            size: 'default',
            speed: 30,
            progress: 0,
            speed_color: {
                "30": {
                    '0%': '#D70015',
                    '100%': '#FE3044 ',
                },
                "60": {
                    '0%': '#EF8F00',
                    '100%': '#F5AB3B',
                },
                "100": {
                    '0%': '#39C16C',
                    '100%': '#21AA54',
                }, 
            },
            appCredibility: "not_install"
        }
    },
    computed: {
        
    },
    created() {
        this.displaySpeed()
        this.showProgress()
    },
    watch: {
        listApp: {
            handler(val) {
                if (val) {
                    this.showProgress()
                    this.displaySpeed()
                }
            },
            deep: true,
        }
    },
    methods: {
        showProgress() {
            this.progress = 0
            setTimeout(()=> {
                let x = setInterval(()=> {
                    this.progress += 20
                    if (this.progress >= 100) {
                        clearInterval(x)
                    }
                }, 200)
            }, 500)
        },
        displaySpeed() {
            // Chưa cài app review
            if (this.listApp.length == 0) {
                this.speed = 30
                this.appCredibility = "not_install"
            } else if (this.listApp.includes("Alireview")) { // Đã cài app AR
                this.speed = 100
                this.appCredibility = "install_alireview"
            } else { // Đã cài app ko có AR
                this.speed = 60
                this.appCredibility = this.listApp.length >= 2 ? "install_multiple" : 'install_' + this.listApp[0].toLowerCase()
            } 
        },
        openAppAR() {
            if (this.speed == 100) {
                window.open('https://app.alireviews.io/', '_blank');
            } else {
                window.open('https://apps.shopify.com/ali-reviews?utm_source=transcy&utm_medium=in-app-score', '_blank');
            }
        }
    }
}
</script>
<style lang="scss">
    .store-credibility {
        box-shadow: 0px 6px 24px -6px #DCE5F4;
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 20px;
        font-size: 16px;
        .#{$skeleton} {
            &-avatar {
                width: 87px;
                height: 87px;
                margin-top: 12px !important;
            }
        }
        &__content {
            display: flex;
            flex-grow: 1;
            &__point {
                width: 87px;
                position: relative;
                &__speed {
                    position: absolute;
                    width: 87px;
                    top: 21px;
                    text-align: center;
                    font-weight: 700;
                    font-size: 30px;
                    line-height: 40px;
                    &.speed-30 {
                        color: #B60012;
                    }
                    &.speed-60 {
                        color: #E19200;
                    }
                    &.speed-100 {
                        color: #015621;
                    }
                }
                .#{$badge} {
                    margin-top: 8px;
                    &.speed-30 {
                        background: #FFF1F1;
                        border-color: #FFF1F1;
                        color: #B60012;
                    }
                    &.speed-60 {
                        background: #FFF7E8;
                        border-color: #FFF7E8;
                        color: #E19200;
                    }
                    &.speed-100 {
                        background: #F0FDF5;
                        border-color: #F0FDF5;
                        color: #015621;
                    }
                }
                &__progress {
                    .a-progress-inner {
                        transform: rotate(180deg);
                    }
                    .a-progress-text {
                        display: none;
                    }
                }
            }
            &__detail {
                margin-left: 24px;
                width: calc(100% - 87px);
                ul.list {
                    list-style: none;
                    li {
                        margin-bottom: 8px;
                        &::before {
                            content: "\2022";
                            color: $primary-color;
                            display: inline-block;
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 24px;
                            margin: 0 8px 0 0;
                            width: 8px;
                        }
                    }
                }
            }
        }
        &__footer {
            margin-left: 111px;
            margin-top: 16px;
            .#{$link} {
                color: $text-color !important;
                margin-left: 24px;
                font-weight: 600;
            }
        }
    }
</style>